import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@mui/material/Typography';

const LIST_WIDTH = 230;

const MapPopper = ({
  children,
  title,
  open,
  anchorEl,
  placement = 'left-start',
  ...props
}) => {
  return (
    <Popper open={open} anchorEl={anchorEl} placement={placement}>
      <Paper
        sx={{padding: 1.0, marginRight: 0.5, width: LIST_WIDTH, ...props.sx}}
      >
        <Typography variant="subtitle1">{title}</Typography>
        {children}
      </Paper>
    </Popper>
  );
};

MapPopper.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  open: PropTypes.bool,
  anchorEl: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.instanceOf(Element),
  ]),
  placement: PropTypes.string,
  sx: PropTypes.object,
};

export default MapPopper;
